import React from 'react';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import PropTypes from 'prop-types';
import { defaultStore } from '../../../redux/stores/GlobalStore';
import { Theme as CustomTheme } from '../Theme';
import { ErrorBoundary } from '../../../utils/errorHandler';
import { GalleryProvider } from '../../../context/GalleryContext';

function Wrapper({ store, children }) {
  return (
    <ErrorBoundary>
      <CustomTheme>
        <Provider store={store}>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            preventDuplicate
          >
            <GalleryProvider>{children}</GalleryProvider>
          </SnackbarProvider>
        </Provider>
      </CustomTheme>
    </ErrorBoundary>
  );
}

Wrapper.propTypes = {
  children: PropTypes.node.isRequired,
  store: PropTypes.object,
};

Wrapper.defaultProps = {
  store: defaultStore,
};

export default Wrapper;
